@if (cellData && params.context) {
	<div class="sh-device-status-cell">
		<prism-status-indicator
			id="sh-device-state-bar"
			class="sh-device-state-bar"
			shape="rectangle"
			[status]="prismState()"
		></prism-status-indicator>
	</div>
}
